import templatesForm from "../../view/facilities/templates_form";

export default {
  facilities: templatesForm,
  ppr_systems: templatesForm,
  ppr_group_systems: templatesForm,
};
